import styled from 'styled-components'

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;

  .select-container {
    .text-input-container {
      background-color: var(--Foreground-Primary, #4d4be7);

      .placeholder {
        opacity: 1;

        color: #fff;

        /* Body 2/Medium */
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */

        cursor: pointer;
      }
    }

    .expand-container {
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
`

export const SelectedItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    max-width: 260px;
  }
`

export const SelectedIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;

    path {
      fill: #fff;
    }
  }
`

export const SelectedItemLabel = styled.label`
  color: #fff;

  /* Body 2/Medium */
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  cursor: pointer;
`
